export const environment = {
  production: true,
  intercom: {
    api_id: 'k29xz30w'
  },
  ATTRIBUTIONS_API_URL: 'https://794lol2h95.execute-api.us-east-1.amazonaws.com/prod',
  ATTRIBUTIONS_API_KEY: 'IWkvD9BnnYoQTCPqrUJdoGPOFGJ2juhrX8PSVdtF0r22JYX3kZCHaDZ48avlytitXnhvXjR2DyKimqLFNr3lFK9L0nXGI1LWxuminwYSbFsMOTHnwSnKw6qeVnzrTxj1' 
};
